import { useEffect, useState } from "react";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { formatNumber } from "../../utils/data/essential";
import PaymentInvoice from "./Invoice";
import useAxios from "../../hooks/useAxios";

const InvoiceVerification = () => {
  const [invoiceData, setInvoiceData] = useState();
  const [subscriber, setSubscriber] = useState();
  const [accountData, setAccountData] = useState();
  const [location,setLocation] = useState()
  const [loading, setLoading] = useState(true);
  const { billId } = useParams();
  const axiosInstance = useAxios();
  useEffect(async () => {
    const res = await axiosInstance.get(`/bills/${billId}`);
    setInvoiceData(res.data);
    setLoading(false);
  }, [billId]);
  useEffect(async () => {
      if (invoiceData !== undefined) {
        // Fetch account data
      const { accountId } = invoiceData;
      const accountResponse = await fetch(`${baseUrl}/accounts/${accountId}`);
      if (!accountResponse.ok) {
        throw new Error("Failed to fetch account data");
      }
        const accountData = await accountResponse.json();
        setAccountData(accountData);
    //   Fetch subscriber data
          if (accountData) {
          const { subscriberId } = accountData;
          const subscriberResponse = await fetch(
            `${baseUrl}/subscribers/${subscriberId}`
          );
          if (!subscriberResponse.ok) {
            throw new Error("Failed to fetch subscriber data");
          }
          const subscriberData = await subscriberResponse.json();
          setSubscriber(subscriberData);
      }
          // Fetch location data
          if (accountData) {
              const { locationId } = accountData;
              const locationResponse = await fetch(
                `${baseUrl}/locations/${locationId}/details`
              );
              if (!locationResponse.ok) {
                throw new Error("Failed to fetch subscriber data");
              }
              const locationData = await locationResponse.json();
              setLocation(locationData);
          }
    }
  }, [invoiceData]);
  return (
    <div style={{ backgroundColor: "#d4d4d7", padding: 10 }}>
      <div className='card mt-2 mb-2 receipt-container'>
        <div className='ml-5 mt-2'>
          <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
            REPUBLIC OF RWANDA
          </p>
          <p style={{ fontSize: 17, fontWeight: 300, color: "#000" }}>
            CITY OF KIGALI
          </p>
          <img
            src='/LOGO_COK.jpg'
            alt='kigali city logo'
            width={100}
            height={100}
          />
          <div className='d-flex justify-content-between flex-wrap'>
            <div className='mt-3'>
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      DISTRICT:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {location ? location[1]?.name : <Skeleton />}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      SECTOR:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {location ? location[2]?.name : <Skeleton />}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      CELL:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {location ? location[3]?.name : <Skeleton />}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      VILLAGE:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {location ? location[4]?.name : <Skeleton />}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='mt-3 mr-2'>
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      Bill NO:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {!loading ? invoiceData?.id : <Skeleton />}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      DATE:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {!loading ? (
                        moment(invoiceData?.datetime).format("DD-MM-YYYY")
                      ) : (
                        <Skeleton />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      FEE PAYER:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {!loading ? accountData?.accountName : <Skeleton />}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      PHONE NO:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {!loading ? (
                        "+" + accountData?.accountNumber
                      ) : (
                        <Skeleton />
                      )}
                    </td>
                  </tr>
                  {subscriber?.tin && (
                    <tr>
                      <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                        TIN NO:
                      </td>
                      <td></td>
                      <td style={{ fontSize: 14 }}>
                        {!loading ? subscriber?.tin : <Skeleton />}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className='d-flex justify-content-center mt-4'>
            <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
              INVOICE
            </p>
          </div>
          <div className='mr-5'>
            <table style={{ width: "100%" }}>
              <thead style={{ backgroundColor: "#124db1", height: 40 }}>
                <th className='pl-2' style={{ color: "#FFF", fontSize: 17 }}>
                  Service
                </th>
                <td style={{ color: "#FFF", fontSize: 17 }}>Amount</td>
              </thead>
              <tr style={{ backgroundColor: "#f5f5f5", height: 40 }}>
                <td className='pl-2' style={{ color: "#616161", fontSize: 17 }}>
                  Security Fee
                </td>
                <td style={{ color: "#616161", fontSize: 17 }}>
                  {!loading ? (
                    formatNumber(invoiceData?.amount) + " RWF"
                  ) : (
                    <Skeleton />
                  )}
                </td>
              </tr>
              <tbody>
                <tr style={{ backgroundColor: "#FFF", height: 40 }}>
                  <td
                    className='pl-2'
                    style={{ color: "#616161", fontSize: 17 }}
                  >
                    Total
                  </td>
                  <td style={{ color: "#000", fontSize: 17 }}>
                    {!loading ? (
                      formatNumber(invoiceData?.amount) + " RWF"
                    ) : (
                      <Skeleton />
                    )}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#f5f5f5", height: 40 }}>
                  <td
                    className='pl-2'
                    style={{ color: "#616161", fontSize: 17 }}
                  >
                    Month
                  </td>
                  <td style={{ color: "#000", fontSize: 17 }}>
                    {!loading ? (
                      moment(invoiceData?.datetime).format("MM/YYYY")
                    ) : (
                      <Skeleton />
                    )}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#FFF", height: 40 }}>
                  <td
                    className='pl-2'
                    style={{ color: "#616161", fontSize: 17 }}
                  >
                    Status
                  </td>
                  <td style={{ color: "#000", fontSize: 17 }}>
                    {!loading ? (
                      <span>
                        {+invoiceData?.status.id === 4 ? (
                          <span>
                            Paid{" "}
                            <i
                              className='fa fa-check-circle'
                              aria-hidden='true'
                              style={{ color: "green" }}
                            />
                          </span>
                        ) : (
                          <span>
                            Unpaid{" "}
                          </span>
                        )}
                      </span>
                    ) : (
                      <skeleton />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Help line section */}
          <div className='mr-5 mt-3' style={{ border: "1.5px solid" }}>
            <div className='d-flex justify-content-center mt-2'>
              <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
                HELP LINE
              </p>
            </div>
            <div className='ml-3 '>
              <p style={{ fontSize: 18, fontWeight: 500, color: "#002033" }}>
                Call center: 0788122922
              </p>
              <p style={{ fontSize: 18, fontWeight: 500, color: "#002033" }}>
                Whatsapp: 0798113341
              </p>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-center mt-2'>
          <PaymentInvoice
            language={{ english: true }}
            date={invoiceData?.datetime}
            period={invoiceData?.period}
            amount={invoiceData?.amount}
            houseId={invoiceData?.houseId}
            accountId={invoiceData?.accountId}
            billId={invoiceData?.id}
            billStatus={invoiceData?.status}
            onHide={() => false}
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceVerification;
